/**
* Content Card Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Card Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'content-card-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.content-card-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--content-card-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '40px',
          autoWidth: true,
          breakpoints: {
            1024: {
              autoWidth: false,
              perPage: 1,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-card-slider', COMPONENT );
} )( app );
